class HcProductForm extends HTMLElement {
  constructor() {
    super();
  
    this.form = this.querySelector('form');
    this.form.querySelector('[name="id"]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cart = document.querySelector('hc-cart-drawer');
    this.submitButton = this.querySelector('[type="submit"]');
    this.submitButtonText = this.submitButton.querySelector('span');
    this.hideErrors = this.dataset.hideErrors === 'true';
    
    // Log preorder detection
    this.logPreorderStatus();
  }

  isMobile() {
    return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  logPreorderStatus() {
    // Only log once per page load
    if (window.hcPreorderLogged) {
      return;
    }
    window.hcPreorderLogged = true;
    
    // Check if preorder component exists
    const preorderComponent = this.querySelector('.product__preorder-info');
    const isPreorderVisible = preorderComponent && !preorderComponent.hasAttribute('hidden');
    
    // Check button data attributes
    const hasPreorderData = this.submitButton.hasAttribute('data-pre-order');
    const buttonText = this.submitButtonText ? this.submitButtonText.textContent.trim() : '';
    
    // Log comprehensive preorder status
    console.log('🛒 PREORDER DETECTION LOG:', {
      'Preorder Component Visible': isPreorderVisible,
      'Button has data-pre-order': hasPreorderData,
      'Button Text': buttonText,
      'Is Preorder Button Text': buttonText.toLowerCase().includes('pre') || buttonText.toLowerCase().includes('orden'),
      'Preorder Component Element': preorderComponent,
      'Submit Button': this.submitButton
    });
    
    // Additional check for variant data if available
    const variantIdInput = this.form.querySelector('[name="id"]');
    if (variantIdInput) {
      console.log('📦 Variant ID:', variantIdInput.value);
    }
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
    
    this.handleErrorMessage();
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    
    if (this.submitButtonText) {
      this.submitButtonText.textContent = window.variantStrings.addingToCart;
    }

    const request = this.prepareRequestConfig();
    const formData = request.formData;

    fetch(`${routes.cart_add_url}`, request.config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status && response.status != 422) {
          this.handleErrorMessage(response.description);
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (soldOutMessage) soldOutMessage.classList.add('hidden');
          return;
        }

        // On mobile, redirect to cart page instead of opening drawer
        if (this.isMobile()) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        // Pass the renderContents without any data to update the cart.
        this.cart.renderContents();
        this.submitButton.classList.remove('loading');
        
        if (this.submitButtonText) {
          this.submitButtonText.textContent = window.variantStrings.addedToCart;
          setTimeout(() => {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }, 2000);
        }
      })
      .catch((e) => {
        console.error(e);
        this.handleErrorMessage();
      })
      .finally(() => {
        this.submitButton.removeAttribute('aria-disabled');
      });
  }

  prepareRequestConfig() {
    const config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      }
    };

    const formData = new FormData(this.form);
    
    // Request our HC cart drawer section
    if (this.cart) {
      formData.append('sections', window.HCCartUtils.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
    }
    
    config.body = formData;
    return { config, formData };
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    
    if (this.errorMessageWrapper) {
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }

  toggleSubmitButton(disable = true, text) {
    if (disable) {
      this.submitButton.setAttribute('disabled', 'disabled');
      if (text && this.submitButtonText) this.submitButtonText.textContent = text;
    } else {
      this.submitButton.removeAttribute('disabled');
      if(this.submitButtonText) {
        this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if(errorMessage && !this.errorMessageWrapper) {
      pushErrorMessage(errorMessage);
    }
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}

customElements.define('hc-product-form', HcProductForm);
